import { BV_REVIEWS_LOADING, BV_REVIEWS_LOADED } from '../actionTypes/BVReviewsActionTypes';

function BVScrollingReducer(state = { isLoaded: undefined }, action = {}) {
    switch (action.type) {
        case BV_REVIEWS_LOADING:
            return { isLoaded: false };
        case BV_REVIEWS_LOADED:
            return { isLoaded: true };
        default:
            return state;
    }
}

BVScrollingReducer.reducerName = 'BVReviews';
export default BVScrollingReducer;
